import { render, staticRenderFns } from "./BarChartAlturaMora.vue?vue&type=template&id=0b718d3f&"
import script from "./BarChartAlturaMora.vue?vue&type=script&lang=js&"
export * from "./BarChartAlturaMora.vue?vue&type=script&lang=js&"
import style0 from "./BarChartAlturaMora.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports